<template>
    <main-section class="main-section--sm pb-0">
        <square-title>인증마크</square-title>

        <marks-list />
    </main-section>
</template>

<script>
import MainSection from "@/components/client/inc/main-section.vue";
import SquareTitle from "../dumb/square-title.vue";
import MarksList from '../dumb/marks-list.vue';

export default {
    components: {
        MainSection,
        SquareTitle,
        MarksList,
    },
};
</script>